import { Theme } from '@mui/material';
import { GeneralContentProps } from '../interfaces/generalContentProps';
import { makeStyles } from 'tss-react/mui';

export const Layout09Styles = makeStyles<GeneralContentProps>()((theme: Theme, props) => ({
  tileGrid: {
    width: '100%',
    display: 'grid',
    gridGap: '1.875rem',
    gridAutoRows: '1fr',
    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: '1fr 1fr',
      gridGap: '2rem 2.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    },
  },
  tileCard: {
    height: '100%',
    borderRadius: '6px',
    padding: '1.875rem 1.5rem',
    backgroundColor: props.contentContainerBackgroundColor || theme.palette.background.paper,
    color: props.contentTextColor || theme.palette.text.primary,
    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem 1.5rem',
      gridTemplateColumns: '1fr 1fr',
    },
  },
  tileHeader: {
    height: 200,
    objectFit: 'contain',
  },
  tileDescription: {
    paddingTop: '1.875rem',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    paddingBottom: '0 !important',
    wordBreak: 'break-word',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '2.5rem',
    },
  },
  cardTitle: {
    fontWeight: 'bold',
    fontSize: '24px',
    lineHeight: '33px',
  },
}));
